// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"456":"3f70f69f","491":"de8428be"}[chunkId] + ".chunk.js";
};